import { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth, notifyAccountChange } from "@/context/AuthContext";

export function useSwitchRole() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  return async (role) => {
    try {
      const { data } = await api.post("/auth/switch-role", { role });
      if (role === "customer") sessionStorage.setItem("vt-scroll-talleres", "1");
      navigate(role === "customer" ? "/explorar" : "/maestro");
      startTransition(() => setUser(data));
      notifyAccountChange();
      toast.success(role === "customer" ? "Ahora estás en tu perfil alumno" : "Volviste a tu perfil Maestro");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
}
